export type AppReleaseInfo = {
  version: string;
  releaseId: string;
  releaseName: string;
  buildTime: string;
  commitSha: string;
};

// Defined globally by Vite in nuxt.config.ts to hardcode frontend build variables.
declare global {
  const __FRONTEND_RELEASE__: AppReleaseInfo | undefined;
}

type AppReleaseInput = Partial<AppReleaseInfo>;

export function buildAppReleaseInfo(input: AppReleaseInput): AppReleaseInfo {
  const version = input.version?.trim() || "0.0.0-dev";
  const commitSha = input.commitSha?.trim() || "";
  const buildTime = input.buildTime?.trim() || new Date().toISOString();
  const releaseName =
    input.releaseName?.trim() ||
    (commitSha ? commitSha.slice(0, 7) : buildTime.slice(0, 10).replace(/-/g, ""));
  const releaseId =
    input.releaseId?.trim() ||
    [version, commitSha || releaseName, buildTime].filter(Boolean).join("-");

  return {
    version,
    releaseId,
    releaseName,
    buildTime,
    commitSha,
  };
}

export function isReleaseUpdateAvailable(
  currentRelease: Pick<AppReleaseInfo, "releaseId">,
  latestRelease: Pick<AppReleaseInfo, "releaseId">,
): boolean {
  return Boolean(latestRelease.releaseId) && currentRelease.releaseId !== latestRelease.releaseId;
}

export function formatReleaseDisplayName(release: Pick<AppReleaseInfo, "version" | "releaseName">): string {
  return release.releaseName
    ? `v${release.version} · ${release.releaseName}`
    : `v${release.version}`;
}